export default "__VITE_ASSET__67a78c4a__"